export default __webpack_public_path__ + "static/media/assign-client-inactive.c16bfd0c.svg";